import { Product } from "utils/types/util.types";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

type Props = {
	textId: string
	product: Product
}

function SingleProduct({
	textId,
	product: {
		name,
		image,
		id,
	},
}: Props) {

	const { t } = useTranslation();

	return (
		<Link to={ `/products/${ id }` } className="flex flex-col bg-stone-50 rounded-3xl overflow-hidden shadow hover:translate-y-[-5px] transition-transform duration-[250ms]">
			<img src={ image } alt={ name } className="w-full object-cover h-[175px] xs:h-[250px] lg:h-auto"/>
			<div className="flex flex-col p-6">
				<div className="text-neutral-950 text-xl sm:text-2xl font-semibold mb-4">
					{ t(`products.${ textId }.title`) }
				</div>
				<div className="text-neutral-950 text-base sm:text-2sm font-light mb-4">
					{ t(`products.${ textId }.description`) }
				</div>
			</div>
		</Link>
	);
}

export default SingleProduct;